import { render, staticRenderFns } from "./DDEnterOTP.vue?vue&type=template&id=c5b06a3c&scoped=true"
import script from "./DDEnterOTP.vue?vue&type=script&lang=js"
export * from "./DDEnterOTP.vue?vue&type=script&lang=js"
import style0 from "./DDEnterOTP.vue?vue&type=style&index=0&id=c5b06a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b06a3c",
  null
  
)

export default component.exports